
import React from 'react';
import PropTypes from 'prop-types';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Select from 'react-select';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  setInsightsCriteriaOrganisation,
  setInsightsCriteriaSubcategory,
  setInsightsCriteriaType,
  setInsightsCriteriaBoundaries,
  setInsightsCriteriaPoi,
  clearInsightsCriteriaPois
} from '../store/actions/criteria-actions';

import {
  fetchRegionalAreaData,
  fetchBoundaries,
  fetchPois
} from '../store/actions/location-actions';

import {
  MultiValueLabel,
  formatOptionsLabel,
  checkDefaultTab,
  isBoundariesBeMultiSelect
} from '../utilities/report-helpers';

import { searchStringInObjectArray } from '../utilities/helpers'

import SVGIcon from '../components/SVGIcon';


const mapStateToProps = (
  { home, insightsCriteria, locations, reports, client, pois },
  ownProps
) => ({
  ...home,
  categories:
    reports.reportDictionary &&
      reports.reportDictionary[ownProps.reportId] &&
      Array.isArray(reports.reportDictionary[ownProps.reportId].subcategories)
      ? reports.reportDictionary[ownProps.reportId].subcategories
      : [],
  organisations:
    reports.reportDictionary &&
      reports.reportDictionary[ownProps.reportId] &&
      Array.isArray(reports.reportDictionary[ownProps.reportId].organisation)
      ? reports.reportDictionary[ownProps.reportId].organisation
      : [],
  ...insightsCriteria,
  boundariesDataLoaded: locations.boundariesDataLoaded,
  boundariesDictionary: locations.boundariesDictionary,
  ...pois,
  tiers:
    reports.reportDictionary &&
      reports.reportDictionary[ownProps.reportId] &&
      Array.isArray(reports.reportDictionary[ownProps.reportId].tiers)
      ? reports.reportDictionary[ownProps.reportId].tiers
      : [],
  organisationsAvailable:
    reports.reportDictionary &&
    reports.reportDictionary[ownProps.reportId] &&
    reports.reportDictionary[ownProps.reportId].organisationsAvailable,
  categoriesAvailable:
    reports.reportDictionary &&
    reports.reportDictionary[ownProps.reportId] &&
    reports.reportDictionary[ownProps.reportId].categoriesAvailable,
  report: reports.reportDictionary[ownProps.reportId],
  country: client.country,
  client,
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setInsightsCriteriaOrganisation,
      setInsightsCriteriaSubcategory,
      fetchRegionalAreaData,
      fetchBoundaries,
      fetchPois,
      setInsightsCriteriaType,
      setInsightsCriteriaBoundaries,
      setInsightsCriteriaPoi,
      clearInsightsCriteriaPois
    },
    dispatch
  );

class Sidebar extends React.Component {
  state = {
    selectedTab: null,
    subcategory: null,
    organisation: null,
    categoryIndex: null,
    category: null,
    regionalArea: null,
    pageUrl: null,
    adm0: null,
    adm1: null,
    adm2: null,
    adm3: null,
    adm4: null,
    poiId: null,
    baseline: { label: `Country`, value: `country` },
  };

  componentDidMount() {
      this.props.fetchBoundaries();
      this.props.fetchPois();
      this.setStateValues();
  }

  componentDidUpdate(prevProps) {
    if (this.props.criteriaId !== prevProps.criteriaId) {
      this.setStateValues();
    }
  }

  setStateValues = () => {

    let categoryIndex;

    if (this.props.insightType === 'organisation') {
      categoryIndex =
        this.props.organisation &&
          this.props.organisation.value &&
          this.props.report.reportOrganisationsDictionary &&
          this.props.report.reportOrganisationsDictionary[
          this.props.organisation.value
          ]
          ? this.props.report.reportOrganisationsDictionary[
            this.props.organisation.value
          ].categoryIndex
          : 0;

    } else {

      categoryIndex =
        this.props.subcategory && this.props.subcategory.categoryIndex
          ? this.props.subcategory.categoryIndex
          : 0;
    }

    let selectedTab = checkDefaultTab('footfall', this.props.insightType, this.props.categoriesAvailable, this.props.organisationsAvailable)

    // Get the url now
    const pageUrl = window.location.pathname;

    const findCategory = () => {
      let categoryObj = {};
      this.props.categories.forEach(category => {
        if (category.categoryIndex === categoryIndex) {
          categoryObj.label = category.labelWithCount;
          categoryObj.value = category.label;
        }
      })
      return categoryObj
    }


    this.setState(() => ({
      selectedTab,
      subcategory: this.props.subcategory,
      organisation: this.props.organisation,
      categoryIndex,
      category: this.props.subcategory ? findCategory() : null,
      pageUrl,
      adm0: this.props.adm0,
      adm1: this.props.adm1,
      adm2: this.props.adm2,
      adm3: this.props.adm3,
      adm4: this.props.adm4,
      poiId: this.props.poiId,
    }));
  };

  setCategory = event => {
    if (event === null) {
      this.setState(() => ({
        category: event,
        categoryIndex: null,
        subcategory: null,
      }));
    } else {
      this.setState(prevProps => ({
        category: event,
        categoryIndex:
          prevProps.categoryIndex !== event.value
            ? event.value
            : prevProps.categoryIndex,
        subcategory:
          prevProps.categoryIndex !== event.value
            ? null
            : prevProps.subcategory,
      }));
    }
  };
  setSubcategory = event => this.setState(() => ({ subcategory: event }));
  setOrganisation = event => {
    this.setState(() => ({ organisation: event }))
    this.props.setInsightsCriteriaOrganisation(
      event,
      event !== null
        ? event.subcategory
        : null
    );
    this.props.clearInsightsCriteriaPois();
    event !== null && (this.props.fetchPois())
  };
  setPoi = event => this.setState(() => ({ poiId: event }));

  setTier = (event, tier) => {
    // All boundaries is single seleciton -> make it as array
    if(event !== null && Array.isArray(event) === false) {
      event = [event]
    }
    // if select all boundaries -> return all.
    if(event !== null && tier === "adm2" && searchStringInObjectArray("All Regional", event, "label") ){
      this.setState(() => ({ adm2: [event[event.length -1]] }) );
    }else if(event !== null && tier === "adm3" && searchStringInObjectArray("All Metro", event, "label")){
      this.setState(() => ({ adm3: [event[event.length -1]] }) );
    }else{
      this.setState(() => ({ [tier]: event }));
    }
  }

  handleResetFilters = () =>
    this.setState(() => ({
      subcategory: null,
      organisation: null,
      regionalArea: null,
      adm0: null,
      adm1: null,
      adm2: null,
      adm3: null,
      adm4: null,
      poiId: null,
    }));
  handleTabChange = index =>
    this.setState(() => ({
      selectedTab: index === 0 ? 'category' : 'organisation',

    }));

  notSet = tier => tier === null || (Array.isArray(tier) && tier.length === 0);


  handleSearch = () => {
    if (this.state.selectedTab === 'category') {
      this.props.setInsightsCriteriaType('category');
      this.props.setInsightsCriteriaSubcategory(this.state.subcategory);
    } else if (this.state.selectedTab === 'organisation') {
      this.setState(() => ({
        subcategory:
          this.state.organisation !== null
            ? {
              label: this.state.organisation.subcategory.label,
              value: this.state.organisation.subcategory.value,
            }
            : null,
      }));
      this.props.setInsightsCriteriaType('organisation');
      this.props.setInsightsCriteriaOrganisation(
        this.state.organisation,
        this.state.organisation !== null
          ? this.state.organisation.subcategory
          : null
      );
    }
    this.props.setInsightsCriteriaBoundaries({
      adm0:
        Array.isArray(this.state.adm0) && this.state.adm0.length > 0
          ? this.state.adm0
          : null,
      adm1:
        Array.isArray(this.state.adm1) && this.state.adm1.length > 0
          ? this.state.adm1
          : null,
      adm2:
        Array.isArray(this.state.adm2) && this.state.adm2.length > 0
          ? this.state.adm2
          : null,
      adm3:
        Array.isArray(this.state.adm3) && this.state.adm3.length > 0
          ? this.state.adm3
          : null,
      adm4:
        Array.isArray(this.state.adm4) && this.state.adm4.length > 0
          ? this.state.adm4
          : null,
      baseline:
        typeof (this.state.baseline) === 'object' && Object.keys(this.state.baseline).length > 0
          ? this.state.baseline
          : null,
    });

    this.props.setInsightsCriteriaPoi(
      Array.isArray(this.state.poiId) && this.state.poiId.length > 0
        ? this.state.poiId
        : null,
    );

    this.props.loadData();
  };

  seachButtonEnabled = () => {
    if (this.state.selectedTab === 'category') {
      return this.state.subcategory === null;
    } else if (this.state.selectedTab === 'organisation') {
      return this.state.organisation === null;
    }
    return false;
  };

  boundariesSelectorDisabled = level => {
    const {  adm1, adm2, adm3, adm4, poiId, selectedTab, organisation } = this.state;
    const notSet = this.notSet;
    if (selectedTab === 'category') {
      switch (level) {
        case 1:
          return !(notSet(adm2) && notSet(adm3) && notSet(adm4));
        case 2:
          return !(notSet(adm1) && notSet(adm3) && notSet(adm4));
        case 3:
          return !(notSet(adm1) && notSet(adm2) && notSet(adm4));
        case 4:
          return !(notSet(adm1) && notSet(adm2) && notSet(adm3));
        default:
          return false;
      }
    } else if (selectedTab === 'organisation') {

    switch (level) {
      case 1:
        return organisation ? !(notSet(adm2) && notSet(adm3) && notSet(adm4) && notSet(poiId)) : true;
      case 2:
        return organisation ? !(notSet(adm1) && notSet(adm3) && notSet(adm4) && notSet(poiId)) : true;
      case 3:
        return organisation ? !(notSet(adm1) && notSet(adm2) && notSet(adm4) && notSet(poiId)) : true;
      case 4:
        return organisation ? !(notSet(adm1) && notSet(adm2) && notSet(adm3) && notSet(poiId)) : true;
      case 'poiId':
        return organisation ? !(notSet(adm1) && notSet(adm2) && notSet(adm3) && notSet(adm4)) : true;
      default:
        return false;
    }
  }
  };

  placeholderRender = (tier) => {

    if (this.state.selectedTab === 'organisation') {
      if (this.state.organisation !== null) {
        return tier !== undefined && this.boundariesSelectorDisabled(tier.level)
          ? 'Other filter selected'
          : 'Type to search'
      } else {
        return 'Select organisation'
      }
    } else {
      return tier !== undefined && this.boundariesSelectorDisabled(tier.level)
        ? 'Other filter selected'
        : 'Type to search'
    }

  }

  render() {
    let subcategoryList = [];

    this.props.categories.forEach(category => {
      if (category.value === this.state.categoryIndex) {
        subcategoryList = category.options
      }
    })
    return (
      <div className="Sidebar">
        <button
          onClick={this.props.toggleSideBar}
          className="Sidebar_close-button"
        >
          <SVGIcon icon="back-arrow" />
        </button>
        <Tabs
          selectedTabClassName="Sidebar_tab_selected"
          defaultIndex={
            this.props.insightType === 'organisation'
              ? 1
              : this.props.categoriesAvailable
                ? 0
                : 1
          }
          onSelect={this.handleTabChange}
        >
          <TabList className="Sidebar_tab-list">
            <Tab
              className="Sidebar_tab"
              disabled={!this.props.categoriesAvailable}
            >
              {this.state.pageUrl === '/travelling-past-insights' ?
                'Geography' :
                'Category'}
            </Tab>
            <Tab
              className="Sidebar_tab"
              disabled={!this.props.organisationsAvailable}
            >
              Organisation
            </Tab>
          </TabList>

          <TabPanel>
            <div className="Sidebar_tab-panel">
              <label htmlFor="category">Category</label>
              <Select
                inputId="category"
                className="Sidebar_select"
                classNamePrefix="Sidebar_select_"
                placeholder="Type to search"
                isClearable={this.props.categories.length > 1}
                isRtl={false}
                isSearchable
                name="organisation"
                onChange={this.setCategory}
                options={this.props.categories.map(category => ({
                  label: category.labelWithCount,
                  value: category.value,
                }))}
                value={this.state.category}
              />
              <label htmlFor="subcategory">Subcategory</label>
              <Select
                key={
                  this.props.subcategory
                    ? this.props.subcategory.name
                    : 'category not selected'
                }
                inputId="subcategory"
                className="Sidebar_select"
                classNamePrefix="Sidebar_select_"
                placeholder={
                  this.state.categoryIndex === null
                    ? 'Select category first'
                    : 'Type to search'
                }
                isDisabled={this.state.categoryIndex === null}
                isClearable
                isRtl={false}
                isSearchable
                name="subcategory"
                options={
                  this.state.categoryIndex !== null &&
                    this.state.categoryIndex !== undefined &&
                    this.props.categories
                    ? subcategoryList
                    : []
                }
                onChange={this.setSubcategory}
                value={this.state.subcategory}
              />
            </div>
          </TabPanel>
          <TabPanel>
            <div className="Sidebar_tab-panel">
              <label htmlFor="subcategory">Organisation</label>
              <Select
                inputId="subcategory"
                className="Sidebar_select"
                classNamePrefix="Sidebar_select_organisation_"
                placeholder="Type to search"
                isDisabled={false}
                isLoading={false}
                isClearable
                isRtl={false}
                isSearchable
                name="organisation"
                options={this.props.organisations}
                onChange={this.setOrganisation}
                value={this.state.organisation}
              />
            </div>
          </TabPanel>
        </Tabs>
        <div className="Sidebar_location-select-wrapper">
          {this.props.tiers.map(tierId => {
            const tier = this.props.boundariesDictionary[tierId];
            return (
              <React.Fragment key={tierId}>
                <label htmlFor={`sidebar-select-${tierId}`}>
                  {tier.name}
                </label>
                <Select
                  inputId={`sidebar-select-${tierId}`}
                  className="Sidebar_select"
                  classNamePrefix="Sidebar_select_"
                  placeholder={this.placeholderRender(tier)}
                  isClearable
                  isLoading={
                    tier === undefined ||
                    !this.props.boundariesDataLoaded ||
                    this.props.boundariesDictionary[tierId] === undefined
                  }
                  isDisabled={
                    tier === undefined ||
                    this.boundariesSelectorDisabled(tier.level) ||
                    !this.props.boundariesDataLoaded ||
                    this.props.boundariesDictionary[tierId] === undefined
                  }
                  isRtl={false}
                  isSearchable
                  name={tierId}
                  options={tier === undefined ? [] : tier.options}
                  components={{ MultiValueLabel }}
                  onChange={e =>
                    this.setTier(
                      e,
                      `adm${tier === undefined ? '' : tier.level}`
                    )
                  }
                  value={
                    tier === undefined ? null : this.state[`adm${tier.level}`]
                  }
                  delimiter=","
                  isMulti={ isBoundariesBeMultiSelect(tier.level, this.state[`adm${tier.level}`])  }
                />
              </React.Fragment>
            );
          })}
          {
            this.props.report.props.showPOIsDropdown &&
              this.props.report.props.showPOIsDropdown === true
            ? (
                <div>
                  <label htmlFor="pois">Point for interest</label>
                  <Select
                    inputId="pois"
                    className="Sidebar_select"
                    classNamePrefix="Sidebar_select_"
                    placeholder={
                      this.state.organisation !== null
                        ? (this.boundariesSelectorDisabled('poiId')
                          ? 'Other filter selected'
                          : 'Type to search')

                        : 'Select organisation'
                    }
                    isDisabled={
                      this.boundariesSelectorDisabled('poiId') ||
                      !this.props.poisDataLoaded
                    }
                    components={{ MultiValueLabel }}
                    formatOptionLabel={formatOptionsLabel}
                    isLoading={!this.props.poisDataLoaded}
                    isClearable
                    isRtl={false}
                    isSearchable
                    isMulti
                    name="pois"
                    delimiter=","
                    options={this.props.poisData}
                    onChange={this.setPoi}
                    value={this.state.poiId}
                  />
                </div>
              ) : ''}


        </div>
        <div className="Sidebar_confirm-reset">
          <button
            className="Sidebar_reset-button"
            onClick={this.handleResetFilters}
          >
            Reset filters
          </button>
          <button
            className="Sidebar_confirm-button"
            onClick={this.handleSearch}
            disabled={this.seachButtonEnabled()}
          >
            Confirm
          </button>
        </div>
      </div>
    );
  }
}

Sidebar.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.object).isRequired,
  organisations: PropTypes.arrayOf(PropTypes.object).isRequired,
  boundariesDataLoaded: PropTypes.bool.isRequired,
  boundariesDictionary: PropTypes.object, // eslint-disable-line
  report: PropTypes.object, // eslint-disable-line
  tiers: PropTypes.arrayOf(PropTypes.string).isRequired,
  setInsightsCriteriaBoundaries: PropTypes.func.isRequired,
  setInsightsCriteriaPoi: PropTypes.func.isRequired,
  setInsightsCriteriaType: PropTypes.func.isRequired,
  organisation: PropTypes.object, // eslint-disable-line
  subcategory: PropTypes.object, // eslint-disable-line
  setInsightsCriteriaOrganisation: PropTypes.func.isRequired,
  setInsightsCriteriaSubcategory: PropTypes.func.isRequired,
  loadData: PropTypes.func.isRequired,
  toggleSideBar: PropTypes.func.isRequired,
  insightType: PropTypes.string,
  categoriesAvailable: PropTypes.bool.isRequired,
  organisationsAvailable: PropTypes.bool.isRequired,
  fetchBoundaries: PropTypes.func.isRequired,
  fetchPois: PropTypes.func.isRequired,
  country: PropTypes.string.isRequired,
  criteriaId: PropTypes.string.isRequired,
  adm1: PropTypes.arrayOf(PropTypes.object),
  adm2: PropTypes.arrayOf(PropTypes.object),
  adm3: PropTypes.arrayOf(PropTypes.object),
  adm4: PropTypes.arrayOf(PropTypes.object),
};

Sidebar.defaultProps = {
  organisation: null,
  subcategory: null,
  insightType: null,
  adm1: null,
  adm2: null,
  adm3: null,
  adm4: null,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Sidebar);
